import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import * as yup from 'yup'
import Grid from '@mui/material/Grid'
import LoadingButton from '@mui/lab/LoadingButton'
import TextField from '@/components/formik/fields/TextField'
import Stack from '@mui/material/Stack'

export type CreatePluginFormValues = {
  _id?: string
  apiKey: string
  apiUrl: string
  pluginUrl: string
}

export type CreatePluginFormProps = {
  initialValues: CreatePluginFormValues
  isSubmitting?: boolean
  onSubmit: (values: CreatePluginFormValues) => void
  onTest?: (values: CreatePluginFormValues) => void
}

const createPluginFormValidationSchema = yup.object().shape({
  apiKey: yup.string().required(),
  apiUrl: yup.string().required(),
  pluginUrl: yup.string().required(),
})




export function CreatePluginForm(props: CreatePluginFormProps) {
  const { initialValues, isSubmitting = false, onSubmit, onTest } = props
  const { t } = useTranslation()

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={createPluginFormValidationSchema}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Grid container rowSpacing={3} columnSpacing={10}>
            <Grid item xs={12} md={12}>
              <Grid container spacing={3} sx={{ mt: '0px' }}>
                <Grid item xs={4}>
                  <TextField fullWidth label={t('page.admin.establishment.form.apiUrl.label')} name="apiUrl" />
                </Grid>
                <Grid item xs={4}>
                  <TextField fullWidth label={t('page.admin.establishment.form.key.label')} name="apiKey" />
                </Grid>
                <Grid item xs={4}>
                  <TextField fullWidth label={t('page.admin.establishment.form.url.label')} name="pluginUrl" />
                </Grid>
                {initialValues._id ? (
                  <Grid item xs={6}>
                    <Stack direction="row" spacing={3}>
                      <LoadingButton fullWidth color="error" disableElevation loading={isSubmitting} onClick={() => alert('Function not implemented yet')} variant="contained">
                        {t('common:button.delete.label')}
                      </LoadingButton>
                      <LoadingButton fullWidth disableElevation loading={isSubmitting} onClick={() => onTest ? onTest(initialValues) : null} variant="contained">
                        {t('common:button.test.label')}
                      </LoadingButton>
                    </Stack>
                  </Grid>
                ) : (
                  <Grid item xs={12}>
                    <LoadingButton fullWidth sx={{ marginTop: 3 }} disableElevation loading={isSubmitting} type="submit" variant="contained">
                      {t('common:button.add.label')}
                    </LoadingButton>
                  </Grid>
                )
                }
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default CreatePluginForm